import React from "react";
import Header from "../../Frontend/Shared/Header/Header";
import Sidebar from "../../Frontend/Shared/Sidebar";
import Footer from "../../Frontend/Shared/Footer/Footer";

import LucknowRouting from "./LucknowRouting";
const LucknowLayout = ({ benchId, benchName, benchCode }) => {
  return (
    <>
      <Header benchId={benchId} benchName={benchName} benchCode={benchCode} />
      <div className="main-center-area">
        <div className="container-fluid">
          <div className="row">
            <Sidebar benchId={7} calendarId={benchId} />
            <LucknowRouting benchId={benchId} benchName={benchName} />
          </div>
        </div>
      </div>
      <Footer benchId={benchId} />
    </>
  );
};
export default LucknowLayout;
